import type { PropsWithChildren } from "react";

export default function PageContainer({ children }: PropsWithChildren) {
  return (
    <div className="@container w-full h-full flex justify-center">
      <div className="h-full w-full @md:w-md @lg:w-lg @xl:w-xl @2xl:w-2xl flex flex-col gap-2 p-4">
        {children}
      </div>
    </div>
  );
}
